import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from './web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class MfaTelephoneService {

  constructor(private webApiServece: WebApiService) { }

  /**
  * 電話認証準備
  * @param phoneNumber 電話番号
  */
  execMfaTelephonePre(phoneNumber: string): Observable<any[]> {
    const requestParam = { 'phone_number': phoneNumber };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/mfa/telephone/pre-request', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
  * 電話認証結果確認
  */
  execMfaTelephoneConfirm(screenId: string): Observable<any> {
    const requestParam = { 'screen_id': screenId };
    return this.webApiServece.callAjaxPostforPolling(environment.apiServerBaseUrl + '/authorization/mfa/telephone/confirm', requestParam)
      .map(cfResponse => {
        // レスポンスをそのまま返す
        return cfResponse.data;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }
}
